<template lang="html">
  <footer id="footer">
   <!--  <section class="newsletter-section">
      <h2>Newsletter</h2>

      <b-form @submit.prevent="onSubmit">
        <b-form-group>
          <b-form-input
            v-model="form.email"
            type="email"
            required
            placeholder="Correo electrónico"
          ></b-form-input>
        </b-form-group>

        <b-button type="submit" class="btn-send">Suscribirse</b-button>
      </b-form>
    </section> -->

  	<section class="footer-section">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-lg-8 col-footer">
                <h5>Mapa del sitio</h5>

                <p class="t-t-upp"><router-link class="link-footer" to="/reglamento-de-mediacion-del-cae">Reglamento de mediación del cae</router-link></p>
                <p class="mt-lg-1 t-t-upp"><router-link class="link-footer" to="/reglamento-de-arbitraje-expedito-y-de-baja-cuantia">Reglamento de arbitraje expedito y de baja cuantía</router-link></p>
                <p class="mt-lg-1 t-t-upp"><router-link class="link-footer" to="/arancel-de-honorarios-de-arbitraje-del-cae">Arancel de honorarios de arbitraje del CAE</router-link></p>
              </div>

							<div class="col-lg-4 col-footer">
                <h5>Mapa del sitio</h5>

                <p><router-link class="link-footer" to="/">Inicio</router-link></p>
                <p><router-link class="link-footer" to="/como-funciona">Cómo funciona</router-link></p>
                <p><router-link class="link-footer" to="/servicios">Servicios</router-link></p>
                <p><router-link class="link-footer" to="/contacto">Contacto</router-link></p>
                <p><router-link class="link-footer" to="/calculadora">Calculadora</router-link></p>

                <p class="mt-2 copy-text">
                  Derecho Reservados © 2022 CAE
                </p>
              </div>
            </div>
          </div>


          <div class="col-lg-3 col-footer col-copyright align-self-center">
            <p class="mb-3">
              <a class="t-150 btn-network btn-instagram" target="_blank" href="#">
                <span><i class="fab fa-instagram"></i></span>
              </a>
              <a class="t-150 btn-network btn-facebook" target="_blank" href="#">
                <span><i class="fab fa-twitter"></i></span>
              </a>
							<a class="t-150 btn-network btn-twitter" target="_blank" href="#">
								<span><i class="fab fa-facebook-f"></i></span>
							</a>
              <a class="t-150 btn-network btn-linkedin" target="_blank" href="#">
                <span><i class="fab fa-linkedin-in"></i></span>
              </a>
            </p>

            <p class="p-sm">
              <strong>Corporativo Sur:</strong><br />
              Calle Aldama 14 A, Col. San Román,<br />
              CP. 2040, Campeche, Campeche.
            </p>

            <p class="mt-2 p-sm">
              <strong>Corporativo Norte:</strong><br />
              Av. Humberto Lobo 770, Col. Del Valle,<br />
              San Pedro Garza García, Nuevo León
            </p>
          </div>
  			</div>
      </div>
  	</section>
  </footer>
</template>

<script>
export default {
  data(){
    return{
      form: {
        email: null
      },
    }
  },

  methods:{
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        appendToast: true
      });
    },

    onSubmit(evt) {
      evt.preventDefault();
      var r = confirm("¿Deseas regístrate en newsletter? ");
      if (r == true) {
        axios.post(tools.url("/api/newsletter"), this.form).then((response)=>{
          this.makeToast('default', response.data.response, 'Correo registrado');
          this.form = {
            name: null,
            email: null,
            msg: null,
            check: null
          };
        }).catch( (error)=> {
          // console.log(error.response);
          let errors = error.response.data;
          // console.log(errors);
          this.makeToast('danger', error.response.data.name, 'Error');
          this.makeToast('danger', error.response.data.email, 'Error');
          this.makeToast('danger', error.response.data.phone, 'Error');
          this.makeToast('danger', error.response.data.msg, 'Error');
        });
      }
    },
  }
}
</script>
